import baseModal from './base-modal.json';
import footer from './footer.json';
import headerProfile from './header-profile.json';
import header from './header.json';
import paymentCardModal from './payment-card-modal.json';
import systemMessages from './system-messages.json';

export default {
  baseModal,
  footer,
  header,
  headerProfile,
  paymentCardModal,
  systemMessages,
};
